import { call, put, takeEvery } from 'redux-saga/effects';

import {
  FETCH_IMAGE_LIBRARY_PAGE,
  FetchImageLibraryPageAction,
  fetchImageLibraryPageFailure,
  fetchImageLibraryPageSuccess
} from 'js/actionCreators/imagesActions';
import { appServices } from 'js/shared/helpers/app-services/AppServices';
import { makeCacheKey } from 'js/shared/helpers/imageLibraryCacheKey';
import { VSCAssetPageItem } from 'js/types';
import { showError } from 'js/actionCreators/uiActions';

interface PagedAssetsResponse {
  items: VSCAssetPageItem[];
  total: number;
  hasMore: boolean;
  expiresAt: number;
}

function* fetchImageLibraryPage({ queryKey, offset, limit }: FetchImageLibraryPageAction) {
  try {
    const cacheKey = makeCacheKey(queryKey, offset);

    const response = (yield call(() =>
      appServices.getPagedImageAssets({
        source: queryKey.source,
        sort: queryKey.sort,
        search: queryKey.search,
        offset,
        limit
      })
    )) as PagedAssetsResponse;

    const items = response.items.map(item => ({ ...item, id: item.id ?? item.projectAssetId }));
    yield put(fetchImageLibraryPageSuccess(cacheKey, items, response.total, response.hasMore, response.expiresAt));
  } catch (error) {
    yield put(fetchImageLibraryPageFailure((error as Error).message));
    yield put(
      showError({
        message: 'There was an issue loading your images.',
        description: `Error: ${(error as Error).message}`
      })
    );
  }
}

export { fetchImageLibraryPage };

export default function* fetchImageLibraryPageSagas() {
  yield takeEvery(FETCH_IMAGE_LIBRARY_PAGE, fetchImageLibraryPage);
}
